export default __webpack_public_path__ + "static/media/bg.84bf15ef.png";